import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import ModernPopupHeader from "../common/ModernPopupHeader";
import ModalModern from "../ModalModern";
import ModernPopupBody from "../common/ModernPopupBody";
import StandardPlaidInstitutionBody from "./utils/StandardPlaidInstitutionBody";
import TestAccountInstitutionBody from "./utils/TestAccountInstitutionBody";

function InstitutionManagementModal({
  institutions = [],
  isLoading = false,
  errorMessage = "",
  onClose,
  onInstitutionConnected,
  onInstitutionRemoved,
  copy,
}) {
  const currentUser = useSelector((state) => state.auth.user);
  const isTestAccount = currentUser?.ista || false;

  const [focusedInstitutionUuid, setFocusedInstitutionUuid] = useState(null);
  const [localError, setLocalError] = useState("");

  // Controlled connection state for header button enablement & actions
  const [isConnectDisabled, setIsConnectDisabled] = useState(false);
  const [connectActionTrigger, setConnectActionTrigger] = useState(0);

  const handleConnectClick = () => {
    // Increment trigger counter to tell child body to initiate connection
    setConnectActionTrigger((prev) => prev + 1);
  };

  return (
    <Fragment>
      <ModalModern onClose={onClose}>
        <ModernPopupHeader onClose={onClose}>
          <div className="header-content-modern-row">
            <div className="header-content-modern-icon-title">
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/institutions.svg`}
                alt={copy?.icon_alt}
              />
              <h3>{copy?.title}</h3>
            </div>

            {/* HEADER CONNECT BUTTON PRESERVED IN ORIGINAL POSITION */}
            <button
              className="cta-button primary rounded small"
              disabled={isConnectDisabled || isLoading}
              onClick={handleConnectClick}
            >
              {isConnectDisabled ? copy?.connecting : copy?.connect}
            </button>
          </div>
        </ModernPopupHeader>

        <ModernPopupBody>
          <div className="modern-popup-body-container">
            {(localError || errorMessage) && (
              <p className="text-danger" style={{ marginBottom: "12px" }}>
                {localError || errorMessage}
              </p>
            )}

            {isTestAccount ? (
              <TestAccountInstitutionBody
                institutions={institutions}
                isLoading={isLoading}
                focusedInstitutionUuid={focusedInstitutionUuid}
                onInstitutionConnected={onInstitutionConnected}
                onInstitutionRemoved={onInstitutionRemoved}
                onSetError={setLocalError}
                copy={copy}
                connectActionTrigger={connectActionTrigger}
                setIsConnectDisabled={setIsConnectDisabled}
              />
            ) : (
              <StandardPlaidInstitutionBody
                institutions={institutions}
                isLoading={isLoading}
                focusedInstitutionUuid={focusedInstitutionUuid}
                setFocusedInstitutionUuid={setFocusedInstitutionUuid}
                onInstitutionConnected={onInstitutionConnected}
                onInstitutionRemoved={onInstitutionRemoved}
                onSetError={setLocalError}
                copy={copy}
                connectActionTrigger={connectActionTrigger}
                setIsConnectDisabled={setIsConnectDisabled}
              />
            )}
          </div>
        </ModernPopupBody>
      </ModalModern>
    </Fragment>
  );
}

export default InstitutionManagementModal;
